module.exports = __webpack_public_path__ + "img/orav_2kl.b8b8e256.jpg";